import {Injectable} from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  ActivatedRouteSnapshot,
  NavigationStart,
  ActivationEnd
} from '@angular/router';
import {environment} from '../../environments/environment';
import {UserService} from './UserService';
import {HttpClient} from '@angular/common/http';
import {Subscription} from 'rxjs/Subscription';

@Injectable()
export class WatchDogService {

  matricule = '';
  dataSubscription: Subscription;

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private http: HttpClient) {
    this.routerListnerStart();
  }


  routerListnerStart() {
    const user = this.userService.getUser();
    this.matricule = user.userName;
    this.router.events.subscribe(event => {
      let fullUrl = '';
      let componentName = '';
      if (event instanceof ActivationEnd && event.snapshot.component) {
        componentName = event.snapshot.component['name'];
       // console.log('componentName', event.snapshot.component['name']);
      }
      fullUrl = window.location.href;
      console.log( fullUrl);
      if (fullUrl && componentName && this.matricule ){
        let payload = {
          url: fullUrl,
          application : 'myshift',
          page : componentName,
          matricule : this.matricule
        };
        console.log('payload ', payload);
        this.dataSubscription = this.http.post(environment.api.watchdog + '/urls', payload)
          .subscribe((d: any) => {
              console.log(d); },
            error => {});
       // this.dataSubscription.unsubscribe();
      }



      // NavigationStart
      // NavigationEnd
      // NavigationCancel
      // NavigationError
      // RoutesRecognized
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/WatchDogService.ts